import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'check-save-modal',
    templateUrl: './check-modal.html',
    styleUrls: ['./check-modal.scss'],
    standalone: false
})

export class CheckModalComponent {
  constructor(public dialogRef: MatDialogRef<CheckModalComponent>) {

  }
}
